import { Model } from '@/clients/http'

import { PaymentGatewayHttpParams, PaymentGatewayResponses } from '@/types'

export class PaymentGatewayModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_PAYMENT_GATEWAY_LIST',
    GET_BY_KEY: 'GET_PAYMENT_GATEWAY_BY_KEY',
    UPDATE: 'UPDATE_PAYMENT_GATEWAY',
  }

  public static readonly endpoints = {
    getList: (props?: PaymentGatewayHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/payment-gateway',
        params: props?.params,
        query: props?.query,
      }),

    getByKey: (props: PaymentGatewayHttpParams.GetByKey) =>
      this.createEndpoint({
        url: '/api/backoffice/payment-gateway/:key',
        params: props?.params,
        query: props?.query,
      }),

    update: (props: PaymentGatewayHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/payment-gateway/:key',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: PaymentGatewayHttpParams.GetList) => {
    return this.createHttpRequest<
      PaymentGatewayResponses.GetList,
      PaymentGatewayResponses.GetListError
    >({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
    })
  }

  public static readonly getByKey = async (props: PaymentGatewayHttpParams.GetByKey) => {
    return this.createHttpRequest<
      PaymentGatewayResponses.GetByKey,
      PaymentGatewayResponses.GetByKeyError
    >({
      correlationKey: this.correlations.GET_BY_KEY,
      payload: {
        method: 'get',
        url: this.endpoints.getByKey(props),
        useBearerToken: true,
      },
    })
  }

  public static readonly update = async (props: PaymentGatewayHttpParams.Update) => {
    return this.createHttpRequest<
      PaymentGatewayResponses.Update,
      PaymentGatewayResponses.UpdateError
    >({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
    })
  }
}
